import { OperationTypes, type Transaction, TransactionDirections } from "@umami/chains";

export const getTransactionTitle = (operation: Transaction): string => {
  switch (operation.operationType) {
    case OperationTypes.SAPLING:
    case OperationTypes.TRANSACTION:
    case OperationTypes.TOKEN_TRANSFER:
    case OperationTypes.SAFE_SEND:
      return operation.txDirection === TransactionDirections.RECEIVE ? "Received" : "Sent";
    case OperationTypes.TOKEN_MINTING:
      return "Minted";
    case OperationTypes.TOKEN_BURNING:
      return "Burned";
    case OperationTypes.CONTRACT_CALL:
      return "Contract Call";
    case OperationTypes.SHIELD:
      return "Shielded";
    case OperationTypes.UNSHIELD:
      return "Unshielded";
    default:
      // TODO: handle other operation types or return a default title
      return "Unknown Operation";
  }
};

export const getTransactionAmount = (operation: Transaction, amount: string) =>
  operation.isNft
    ? `x${operation.amount}`
    : operation.txDirection === TransactionDirections.RECEIVE
      ? `+${amount}`
      : `-${amount}`;
